import style from "./EmploymentDetails.module.css";
import { RootState } from "@/store/dtm";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { selectCurrentEmployment } from "@/slices/currentEmploymentSlice";
import { selectPreviousEmployment } from "@/slices/previousEmploymentSlice";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";

export default function EmploymentDetails(props: any) {
    const navigate = useNavigate();
    const application = useSelector(
        (state: RootState) => state.application.application
    );
    const applicant = useSelector(
        (state: RootState) => state.applicant.applicant
    );
    const employment = useSelector(
        (state: RootState) => state.employment.employment
    );
    const [showEdit, setShowEdit] = useState(false);
    const [incomeAmount, setIncomeAmount] = useState("");
    const currentEmployment = useSelector(selectCurrentEmployment).employments;
    const previousEmployment = useSelector(selectPreviousEmployment).employments;

    const methods = useForm({
        defaultValues: {
            employmentStatus: "",
            employmentType: "",
            payrollType: "",
            income: "",
            payrollFrequency: ""
        },
    });

    useEffect(() => {
        methods.setValue("employmentStatus", employment.status);
        methods.setValue("employmentType", employment.type);
        methods.setValue("payrollType", employment.payrollType);
        methods.setValue("payrollFrequency", employment.payrollFrequency);

        const formattedIncome = employment.income.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("income", formattedIncome);
        setIncomeAmount(formattedIncome);
    }, []);

    useEffect(() => {
        const formattedIncome = employment.income.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        methods.setValue("income", employment ? employment.income == 0 ? "" : formattedIncome : "");
        setIncomeAmount(employment ? employment.income == 0 ? "" : formattedIncome : "");
    }, [employment])

    return (
        <div className="mt-5">
            <div className="flex flex-row justify-between mt-5">
                <h2>Employment Details</h2>
                {!showEdit && (
                    <h3
                        className="brand-blue-text text-xs grid grid-flow-col cursor-pointer"
                        onClick={() => {
                            navigate("/single/employment", { state: { editMode: true } });
                        }}
                    >
                        <img
                            src="assets/edit-icon.svg"
                            className={style.editIcon}
                            alt="edit"
                        />
                        <span>Edit</span>
                    </h3>
                )}
            </div>

            {currentEmployment.map((position: any) => (
                <div key={position.id} className="mt-3">
                    {position.status === "employed" || position.status === "selfemployed" ?
                        <>
                            <label>{position.employerName}</label><span
                                className="ml-4"
                                style={{
                                    background: "#D8ECDC",
                                    color: "#06560F",
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    borderRadius: 12,
                                    fontSize: 14,
                                    fontWeight: "bold"
                                }}>
                                {"CURRENT"}
                            </span>
                            <p>{position.payrollType == "salary" ? "Salaried" :
                                position.payrollType == "commission" ? "Commission Based" :
                                position.payrollType == "hourlyguaranteed" ? "Hourly (Guaranteed)" :
                                position.payrollType == "hourlynonguaranteed" ? "Hourly (Non-Guaranteed)" :
                                position.payrollType == "business" ? "Net Income" :
                                position.payrollType == "commission" ? "Commission" :
                                position.payrollType == "dividends" ? "Dividends" : "Other"} - {position.jobTitle}</p>
                            <p className="mt-1">
                                <span className="mr-1">
                                    {position.type == "fulltime" ? "Full-time" :
                                        position.type == "parttime" ? "Part-time" :
                                            position.type == "seasonalfullparttime" ? "Seasonal Full/Part Time" :
                                                position.type == "contract" ? "Contract" : "Self Employed"}
                                </span>
                                -
                                <span className="ml-1">
                                    {position.employmentYears > 0 && position.employmentYears + " Year" + (position.employmentYears != 1 ? "s" : "")}
                                    {position.employmentYears > 0 && position.employmentMonths > 0 && " & "}
                                    {position.employmentMonths > 0 && position.employmentMonths + " Month" + (position.employmentMonths != 1 ? "s" : "")}
                                </span>
                            </p>
                            <div className="flex md:flex-row flex-col">
                                <div className={clsx(style.twoColFirst, "flex md:flex-row justify-between")}>
                                    <p>Income:</p>
                                    <p className="mr-5">{position.income.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })} / {position.payrollFrequency}</p>
                                </div>
                                <div className={clsx(style.twoColFirst, "flex md:flex-row justify-between")}>
                                </div>
                            </div>
                            <div className="flex md:flex-row flex-col">
                                <div className={clsx(style.twoColFirst, "flex md:flex-row justify-between")}>
                                    <p>Bonus:</p>
                                    <p className="mr-5">{position.bonusIncome.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        {position.hasBonusIncome ? "/" + position.bonusIncomeFrequency : " - "}</p>
                                </div>
                                <div className={clsx(style.twoColFirst, "flex md:flex-row justify-between")}>
                                    <p>Overtime:</p>
                                    <p className="mr-5">{position.overtimeIncome.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        {position.hasOvertimeIncome ? "/" + position.overtimeIncomeFrequency : " - "}</p>
                                </div>
                            </div>
                            <div className="flex md:flex-row flex-col">
                                <div className={clsx(style.twoColFirst, "flex md:flex-row justify-between")}>
                                    <p>Commission:</p>
                                    <p className="mr-5">{position.commissionIncome.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        {position.hasCommissionIncome ? "/" + position.commissionIncomeFrequency : " - "}</p>
                                </div>
                                <div className={clsx(style.twoColFirst, "flex md:flex-row justify-between")}>
                                    <p>Declared Tips:</p>
                                    <p className="mr-5">{position.tipsIncome.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        {position.hasTipsIncome ? "/" + position.tipsIncomeFrequency : " - "}</p>
                                </div>
                            </div>
                        </>
                        :
                        position.status === "retired" ?
                            <>
                                <span
                                    className=""
                                    style={{
                                        background: "#D8ECDC",
                                        color: "#06560F",
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        paddingTop: 2,
                                        paddingBottom: 2,
                                        borderRadius: 12,
                                        fontSize: 14,
                                        fontWeight: "bold"
                                    }}>
                                    {"RETIRED"}
                                </span>
                                <p className="mt-1">
                                    <span className="ml-1 mt-2">
                                        {position.notWorkingYears > 0 && position.notWorkingYears + " Year" + (position.notWorkingYears != 1 ? "s" : "")}
                                        {position.notWorkingYears > 0 && position.notWorkingMonths > 0 && " & "}
                                        {position.notWorkingMonths > 0 && position.notWorkingMonths + " Month" + (position.notWorkingMonths != 1 ? "s" : "")}
                                    </span>
                                </p>
                                {position.otherIncome.map((income: any) => (
                                    <div key={income.id} className="flex md:flex-row flex-col">
                                        <div className={clsx(style.twoColFirst, "flex md:flex-row justify-between")}>
                                            <p>{income.type == "cpp" ? "CPP" 
                                            : income.type == "oas" ? "OAS" 
                                            : income.type == "employerpension" ? "Employer Pension" 
                                            : income.type == "permanentdisability" ? "Permanent Disability" 
                                            : income.type == "rrif" ? "RRIF" : "Unknown"}:</p>
                                            <p className="mr-5">{income.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                {" / " + income.frequency}</p>
                                        </div>
                                    </div>
                                ))}
                            </>
                            :
                            <>
                                <span
                                    className=""
                                    style={{
                                        background: "#FFF8E9",
                                        color: "#946A00",
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        paddingTop: 2,
                                        paddingBottom: 2,
                                        borderRadius: 12,
                                        fontSize: 14,
                                        fontWeight: "bold"
                                    }}>
                                    {"NOT EMPLOYED"}
                                </span>
                                <p className="mt-1">
                                    <span className="ml-1 mt-2">
                                        {position.notWorkingYears > 0 && position.notWorkingYears + " Year" + (position.notWorkingYears != 1 ? "s" : "")}
                                        {position.notWorkingYears > 0 && position.notWorkingMonths > 0 && " & "}
                                        {position.notWorkingMonths > 0 && position.notWorkingMonths + " Month" + (position.notWorkingMonths != 1 ? "s" : "")}
                                    </span>
                                </p>
                            </>
                    }
                </div>
            ))}
        </div>
    );
}